import { RegisteredComponent } from "@builder.io/sdk-react";

export const pdfViewerBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "PDF Viewer",
  inputs: [
    {
      name: "sourceUrl",
      type: "AprimoAssetSelector",
      options: {
        searchingExpression:
          'Contentstatus = "Released" AND File.Version.Extension = "pdf" AND Classification.NamePath = "/DAM/Audience/External" AND Classification.NamePath = "/DAM/Status/Available"',
      },
      required: true,
      localized: true,
      helperText:
        "Select the source PDF from the DAM (Aprimo). Only PDFs which are permitted to use on the website are selectable; therefore, archived, draft or internal assets can't be selected.",
    },
  ],
  defaultStyles: {
    width: "100%",
  },
};
